<template>
    <SharedAppIcon
        :name="config.name"
        :size="iconSize"
        :stroke-width="resolvedStrokeWidth"
        :class="iconClass"
    />
</template>

<script setup lang="ts">
import type { IconBlockConfig } from '~~/layers/base/types/blockConfigs'

const props = defineProps<{
    config: IconBlockConfig
    /** Overrides `config.strokeWidth` when set. */
    strokeWidth?: string | number
}>()

const iconSize = computed(() => props.config.size ?? 24)

const resolvedStrokeWidth = computed(() => props.strokeWidth ?? props.config.strokeWidth)

const iconClass = computed(() =>
    ['inline-flex shrink-0 text-current', props.config.ui].filter(Boolean).join(' ')
)
</script>
